import { useEffect, useMemo } from 'react'
import useAxios from 'axios-hooks'
import { useProgramContext } from 'providers/programProvider'
import { selectors } from 'providers/programProvider/systemReducer'
import { actions } from 'providers/programProvider/systemReducer/actionTypes'
import bindArgs from 'utils/bindArgs'

export const useSystem = () => {
  const [state, dispatch] = useProgramContext()
  const { setVersion, setVersionLoading, setVersionError } = bindArgs(actions, dispatch)
  const {
    getGlobalVersion,
    getLastDeploymentDate,
    getEnvironment,
    getLastImportedYMFileDate,
    isVersionLoading,
    getVersionError
  } = bindArgs(selectors, state)

  const [{ data, loading, error }] = useAxios(
    { url: 'system/version' },
    { manual: !!getGlobalVersion() },
  )

  useEffect(() => {
    error !== getVersionError() && setVersionError(error)
    loading !== isVersionLoading() && setVersionLoading(loading)
    data && setVersion(data)
  }, [loading, error, data])

  return useMemo(
    () => ({
      versionLoading: isVersionLoading(),
      versionError: getVersionError(),
      globalVersion: getGlobalVersion(),
      lastDeploymentDate: getLastDeploymentDate(),
      environment: getEnvironment(),
      lastImportedYMFileDate: getLastImportedYMFileDate(),
    }),
    [
      isVersionLoading(),
      getVersionError(),
      getGlobalVersion(),
      getLastDeploymentDate(),
      getEnvironment(),
      getLastImportedYMFileDate(),
    ],
  )
}
